"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _withScopeId = n => ((0, vue_2.pushScopeId)("data-v-2f5927e6"), n = n(), (0, vue_2.popScopeId)(), n);
const _hoisted_1 = {
    key: 0,
    class: "fixed z-50 inset-0 overflow-y-auto bg-opacity-75 bg-gray-darkest"
};
const _hoisted_2 = { class: "flex items-start justify-center min-h-screen pt-4 px-4 pb-20 text-center" };
const _hoisted_3 = { class: "sm:flex sm:items-start min-w-full" };
const _hoisted_4 = { class: "sm:text-left min-w-full" };
const _hoisted_5 = { class: "flex flex-row justify-between items-center text-lg leading-6 font-bold text-gray-darkest uppercase border-[#00000061] border-b-2 pb-4" };
const _hoisted_6 = { key: 0 };
const _hoisted_7 = { key: 1 };
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "marso-icon-close" }, null, -1));
const _hoisted_9 = {
    key: 0,
    class: "flex justify-center items-center modal-loading p-4"
};
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "icon marso-icon-refresh" }, null, -1));
const _hoisted_11 = {
    key: 1,
    class: "mt-4"
};
const vue_3 = require("vue");
const i18n_1 = require("../common/i18n");
exports.default = (0, vue_1.defineComponent)({
    __name: 'Modal',
    props: {
        title: {
            type: String,
            default: "Modal",
        },
        isOpen: {
            type: Boolean,
            default: false,
        },
        isLoading: {
            type: Boolean,
            default: false,
        },
        widthClasses: {
            type: String,
            default: "w-full sm:w-4/5 max-w-full",
        },
        closeable: {
            type: Boolean,
            default: true,
        },
        backgroundColorClass: {
            type: String,
            default: "bg-white",
        },
    },
    emits: ["close"],
    setup(__props, { emit }) {
        const props = __props;
        (0, vue_3.watch)(() => props.isOpen, () => {
            if (props.isOpen) {
                document.body.classList.add("overflow-hidden");
            }
            else {
                document.body.classList.remove("overflow-hidden");
            }
        });
        const close = () => emit("close");
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(vue_2.Transition, { name: "fade" }, {
                default: (0, vue_2.withCtx)(() => [
                    (__props.isOpen)
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                            (0, vue_2.createElementVNode)("div", _hoisted_2, [
                                (0, vue_2.createElementVNode)("div", {
                                    onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.$emit('close'))),
                                    class: "fixed inset-0 transition-opacity"
                                }),
                                (0, vue_2.createElementVNode)("div", {
                                    class: (0, vue_2.normalizeClass)(["inline-block align-bottom bg-white rounded-lg text-left overflow-visible shadow-xl sm:my-8 sm:align-middle transform", __props.widthClasses])
                                }, [
                                    (0, vue_2.createElementVNode)("div", {
                                        class: (0, vue_2.normalizeClass)(["rounded-lg px-4 pt-5 pb-4 sm:p-6 sm:pb-4", __props.backgroundColorClass])
                                    }, [
                                        (0, vue_2.createElementVNode)("div", _hoisted_3, [
                                            (0, vue_2.createElementVNode)("div", _hoisted_4, [
                                                (0, vue_2.createElementVNode)("h3", _hoisted_5, [
                                                    (__props.isLoading)
                                                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_6, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("loading", "Loading", "modal")) + "...", 1))
                                                        : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_7, (0, vue_2.toDisplayString)(__props.title), 1)),
                                                    (__props.closeable)
                                                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", {
                                                            key: 2,
                                                            class: "text-[#929292] text-[12px] cursor-pointer",
                                                            onClick: close
                                                        }, [
                                                            (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("close", "Close", "modal")) + " ", 1),
                                                            _hoisted_8
                                                        ]))
                                                        : (0, vue_2.createCommentVNode)("", true)
                                                ]),
                                                (__props.isLoading)
                                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_9, [
                                                        (0, vue_2.renderSlot)(_ctx.$slots, "loading", {}, () => [
                                                            _hoisted_10
                                                        ])
                                                    ]))
                                                    : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_11, [
                                                        (0, vue_2.renderSlot)(_ctx.$slots, "default")
                                                    ]))
                                            ])
                                        ])
                                    ], 2)
                                ], 2)
                            ])
                        ]))
                        : (0, vue_2.createCommentVNode)("", true)
                ]),
                _: 3
            }));
        };
    }
});
